const Foxtrot = {
    name: "Foxtrot",
    bpm: 100,
    signature: "4/4",
    introMeasures: 8,
    pattern: [

    ]
};

export default Foxtrot;